import PropTypes from 'prop-types';
import DoughnutChart from 'Shared/components/charts/doughnut-chart';
import { formatAmount } from 'Shared/util/formatters';
import { colors } from 'Shared/util/theme';
import styles from './landing-doughnut-chart.css';


const generateChartData = (circleColor) => ({
  labels: [],
  datasets: [{
    data: [1],
    backgroundColor: [circleColor || colors.main],
    borderWidth: 0,
  }],
});

const getChartOptions = () => ({
  cutoutPercentage: 80,
  events: [], // Remove all events, ex. hover
  legend: {
    display: false,
  },
  tooltips: {
    enabled: false,
  },
});


const LandingDoughnutChart = ({
  title,
  numberAmount,
  sumAmount,
  currency,
  circleColor,
  active,
}) => {
  const chartData = generateChartData(circleColor);
  const chartOptions = getChartOptions();
  return (
    <div className={`${styles.container} ${active ? styles.active : ''}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.chartContainer}>
        <div className={styles.innerCircle}>
          <span>{numberAmount}</span>
        </div>
        <DoughnutChart data={chartData} options={chartOptions} />
      </div>
      <div className={styles.amount}>
        <span>{formatAmount(sumAmount)}</span>
        <span className={styles.currency}>{` ${currency}`}</span>
      </div>
    </div>
  );
};

LandingDoughnutChart.propTypes = {
  title: PropTypes.string.isRequired,
  numberAmount: PropTypes.number.isRequired,
  sumAmount: PropTypes.number.isRequired,
  currency: PropTypes.string,
  circleColor: PropTypes.string,
  active: PropTypes.bool,
};

export default LandingDoughnutChart;
